import React, { useMemo, useState } from 'react'
import styled from 'styled-components'
import { Container, Col, Row, Carousel } from 'react-bootstrap'
import SharedTitle from '~/components/UI/SharedTitle'
import Text from '~/components/UI/Text'
import { useTranslation } from '~/i18n'
import Box from '~/components/UI/Box'
import Icon from '~/components/UI/Icon'
import { COLORS } from '~/components/UI/Constants'
import Link from '~/components/UI/Link'
import breakpoints from '~/components/UI/breakpoints'
import Desktop from '~/components/UI/Desktop'
import Mobile from '~/components/UI/Mobile'
import Popup from './Section6Compare/Popup'

const MyContainer = styled.div`
  padding: 0;
  padding-bottom: 80px;
  background-color: #f9fafc;
  > div {
    padding: 0
  }
`

const ContentBox = styled(Box)`
  padding: 20px;
  width: 100%;
  min-height: 360px;
  border-radius: 8px;
  box-shadow: 0 2px 10px 0 rgba(0, 85, 255, 0.24);
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  ${breakpoints.md} {
    display: block;
  }
  ${breakpoints.lg} {
    padding: 48px 32px;
  }
`

const StyledIcon = styled(Icon)`
  font-size: 60px;
  ::before {
    color: #0055ff;
  }
`

interface Props {
  title: string
  icon: string
  desc: string
  link: string
}

const getContents = (t: any) => ([
  {
    title: t`Vốn đầu tư - Thanh toán`,
    icon: 'coins',
    desc: t`Đầu tư bất động sản với số vốn vừa phải và thanh toán theo tiến độ được chia nhỏ.`,
    link: ''
  },
  {
    title: t`Lợi nhuận - Tính an toàn`,
    icon: 'interest',
    desc: t`Bất động sản có tiềm năng sinh lời tốt, lợi nhuận cam kết còn được ngân hàng uy tín phát hành thư bảo lãnh.`,
    link: ''
  },
  {
    title: t`Hợp đồng - Pháp lý`,
    icon: 'security',
    desc: t`Hợp đồng và tất cả thủ tục pháp lý rõ ràng, đơn giản, đều sẽ do Infina thực hiện giúp bạn.`,
    link: ''
  }
])

const Item: React.FC<Props> = ({ title, icon, desc, link }) => {
  const [t] = useTranslation()
  return (
    <ContentBox>
      <StyledIcon name={icon} />
      <Text padding='24px 0 16px 0' size={24} bold>
        {title}
      </Text>
      <Text padding='0 0 24px 0'>
        {desc}
      </Text>
      <Link href={link}>
        <Text color={COLORS.PRIMARY} bold>
          {t`Đọc Thêm >`}
        </Text>
      </Link>
    </ContentBox>
  )
}

const Section6Compare = () => {
  const [t] = useTranslation()
  const [show, setShow] = useState(false)
  const [contentIndex, setContentIndex] = useState(1)
  const onClose = () => setShow(prev => !prev)
  const contents = useMemo(() => getContents(t), [])
  const showContent = (index: number) => {
    setContentIndex(index)
    setShow(true)
  }

  const getHandler = (index: number) => {
    return (evt: any) => {
      evt.preventDefault()
      showContent(index)
    }
  }

  const desktopContents = useMemo(() => {
    return contents.map((content, index) => (
      <Col md={4} className='mb-4' key={content.title}>
        <Link href='#' onClick={getHandler(index + 1)}>
          <Item {...content} />
        </Link>
      </Col>
    ))
  }, [contents])

  const mobileContents = useMemo(() => {
    const _contents = contents.map((content, index) => (
      <Carousel.Item key={content.title}>
        <div style={{ padding: 30 }}>
          <Link href='#' onClick={getHandler(index + 1)}>
            <Item {...content} />
          </Link>
        </div>
      </Carousel.Item>
    ))

    return (
      <Carousel>
        {_contents}
      </Carousel>
    )
  }, [contents])

  return (
    <MyContainer>
      <Popup show={show} contentIndex={contentIndex} handleClose={onClose} />
      <Container>
        <SharedTitle centered padding='40px 0'>
          {t`So sánh với hình thức truyền thống`}
        </SharedTitle>
        <Desktop>
          <Row>
            {desktopContents}
          </Row>
        </Desktop>
        <Mobile>
          {mobileContents}
        </Mobile>
      </Container>
    </MyContainer>
  )
}

export default Section6Compare